interface AuthResponse {
  signed_in: boolean;
  urls: {
    signup: string;
    signin: string;
    logout: string;
  };
}

async function fetchAuth(): Promise<AuthResponse | null> {
  try {
    const res = await fetch("/api/auth/me");
    if (!res.ok) return null;
    return res.json();
  } catch {
    return null;
  }
}

async function main() {
  const container = document.getElementById("auth") || document.body;
  container.innerHTML = "Checking sign-in status…";

  const data = await fetchAuth();
  if (!data) {
    container.innerHTML = "Error checking auth status.";
    return;
  }

  if (!data.signed_in) {
    container.innerHTML = `
      <button id="signup">Sign up</button>
      <button id="signin">Sign in</button>
    `;
    document.getElementById("signup")!.onclick = () =>
      (window.location.href = data.urls.signup);
    document.getElementById("signin")!.onclick = () =>
      (window.location.href = data.urls.signin);
  } else {
    container.innerHTML = `
      <p>You are signed in ✅</p>
      <button id="signout">Sign out</button>
    `;
    document.getElementById("signout")!.onclick = () =>
      (window.location.href = data.urls.logout);
  }
}

main();
